import React, { useState } from "react";
import { AddModal } from "../../components/molecules/AddModal";
import { Subheader } from "../../components/molecules/UpdateModal";
import { TextField } from "@mui/material";
import { PostBackoffice } from "../../utils/request";

interface IComponentOwnProps {
  open: boolean;
  closeModal: Function;
  serialId: string | undefined
  description: string | undefined
  onSaved: (description: string | null) => void
}
export const AddMachineDescription = (props: IComponentOwnProps) => {
  const [description, setDescription] = useState<string | undefined>(props.description)
  const [savingState, setSavingState] = useState<"idle" | "saving" | "failed">("idle");

  const saveDescription = async () => {

    const newDescription = {
      id: props.serialId,
      text: description ?? null
    }

    setSavingState("saving")
    try {
      await PostBackoffice('cmd/machine/description/set', newDescription)
      setSavingState("idle")
      props.onSaved(newDescription.text)
      props.closeModal();

    } catch (error) {
      setSavingState("failed")
      console.error("cannot save hub description", error)
    }
  }

  return (
    <div>
      <AddModal
        title={'Add description'}
        saving={savingState}
        open={props.open}
        savingFailedMessage={'Saving failed. Please check your inputs below and your internet connection and try again.'}
        closeModal={() => props.closeModal()}
        onSave={saveDescription}
        maxWidth="lg"
      >
        <Subheader title={'Hub Description'} />
        <TextField
          autoFocus
          margin="normal"
          id="description_input_field"
          label="Hub Description"
          defaultValue={description}
          type="text"
          fullWidth
          onChange={(event) => setDescription(event.target.value)}
          helperText={"Please enter a description."}
        />
      </AddModal>

    </div >
  )
}